import React from 'react'
import classnames from 'classnames'

import { HOURS, HOUR_HEIGHT, DAY_HEIGHT } from './utils'
import { useResourcesByDate } from '../../hooks'

import DayOfTheWeek from './components/DayOfTheWeek'
import Day from './components/Day'
import { ClipLoader } from 'react-spinners'

export default function WeekView() {
  const { currentDate, isFetchingResources, resourcesSortedByDate } = useResourcesByDate()

  return (
    <div className="" style={{width: 'calc(100%)', height: 'calc(100% - 77px)', overflow: 'hidden', backgroundColor: 'rgba(0,0,0,0.03)'}}>
      <DayOfTheWeek dates={resourcesSortedByDate.map(item=>item.date)} currentDate={currentDate}/>
      {
        isFetchingResources ?
        <div className="d-flex w-100 h-100 align-items-center justify-content-center"><ClipLoader color="#20a8d8"/></div> :
        <>

          <div className="w-100" style={{overflowY: 'scroll', height: `calc(100% - ${DAY_HEIGHT})`}}>
            <div className="d-none bg-white" style={{ width: '80px', verticalAlign: 'top'}}>
              { HOURS.map((hour, index)=>(<div key={index} className={classnames("text-secondary d-inline-block w-100 pt-1 pl-1 text-uppercase", {"border-top": index != 0})} style={{ height: HOUR_HEIGHT }}><small>{ hour }</small></div>)) }
            </div>
            { resourcesSortedByDate.map( (item, index) =>(<Day index={index} key={item.date} { ...item } />)) }
          </div>
        </>
      }
    </div>
  )
}